const Gateway = {
  AISColor: "#b2d235",
  AIS2Color: "#b2d235",
  InfobipColor: "#fe5901",
  InfobipLocalColor: "#fe5901",
  CMColor: "#0f1f1f",
  TencentColor: "#0e95e9",
  MoceanColor: "#0746a6",
  WavecellColor: "#cb2323",
  OneWaySMSColor: "#396c33",
  MessageBirdColor: "#2481d7",
  Every8DColor: "#e95007",
  SMStoColor: "#6091f2",
  ViHATColor: "#03aef4",
  ThaibulksmsColor: "#007aff",
  NXCloudColor: "#92ce16",
  BusyBeeColor: "#ffb400",
  BusyBeeMKTColor: "#ffb400",
  IbazaarColor: "#432b83",
  trueColor: "#dc1c23",
  BulkMalaysiaColor: "#ed2525",
  M360Color: "#008cf1",
  M360OTPColor: "#008cf1",
  ClickSendColor: "#f830a3",
  M360SMPPColor: "#799af7",
  M360OTPSMPPColor: "#1988b8",
  SMSalaColor: "#f7567c",
  ViHATMKTColor: "#03aef4",
  InnopassMKTColor: "#1890ff",
  InnopassOTPColor: "#1890ff",
  VB_8x8Color: "#1890ff",
  LanckteleColor: "#9b51e0",
  MoceanInterColor: "#0746a6",
  TalktideColor: "#3ab15d",
  TalktideMKTColor: "#3ab13f",
  BraxisColor: "#ffc52f",
  MittoColor: "#FC0079",
  PromotexterColor: "#007bff",
  CTLMKTColor: "#9ca2a9",
  CTLOTPColor: "#9ca2a9",
  AstralColor: "#5b3df5",

  AIS: "AIS",
  AIS2: "AIS2",
  Infobip: "Infobip",
  InfobipLocal: "InfobipLocal",
  Tencent: "Tencent",
  CM: "CM",
  Mocean: "Mocean",
  Wavecell: "Wavecell-Onemoby_OTP",
  WavecellOneMobyNotify: "Wavecell-Onemoby_Notify",
  Wavecell1MobyLocalNotify: "Wavecell-1moby_Local_Notify",
  Wavecell1MobyLocalOTP: "Wavecell-1moby_Local_OTP",
  OneWaySMS: "OneWaySMS",
  MessageBird: "MessageBird",
  Every8D: "Every8D",
  SMSto: "SMSto",
  ViHAT: "VihatDR",
  Thaibulksms: "Thaibulksms",
  NXCloud: "NXCloud",
  BusyBee: "BusyBee",
  BusyBeeMKT: "BusyBeeMKT",
  Ibazaar: "Ibazaar",
  true: "true",
  BulkMalaysia: "BulkMalaysia",
  M360: "M360",
  M360OTP: "M360OTP",
  ClickSend: "ClickSend",
  M360SMPP: "M360-SMPP",
  M360OTPSMPP: "M360OTP-SMPP",
  SMSala: "SMSala",
  ViHATMKT: "VihatHQ",
  InnopassMKT: "InnopassLocal-08",
  InnopassOTP: "InnopassInter-07",
  VB_8x8: "VB_8x8",
  Lancktele: "Lancktele",
  MoceanInter: "MoceanInter",
  Talktide: "TalktideOTP",
  TalktideMKT: "TalktideMKT",
  Braxis: "Braxis",
  Mitto: "Mitto",
  Promotexter: "Promotexter",
  CTLMKT: "CTLMKT",
  CTLOTP: "CTLOTP",
  Astral: "Astral",
};

const GatewayColor = (gateway) => {
  if (!gateway) return "";
  if (/^Wavecell/.test(gateway)) return Gateway.WavecellColor;
  if (/^M360/.test(gateway) || gateway === "ViHAT-MKT" || /^CTL/.test(gateway)) {
    gateway = String(gateway).replace("-", "");
  }

  return Gateway[`${gateway}Color`] || "";
};

const GatewayName = (gateway) => {
  if (!gateway) return "-";
  if (gateway === "Wavecell-Onemoby_Notify")
    return Gateway.WavecellOneMobyNotify;
  else if (gateway === "Wavecell-1moby_Local_Notify")
    return Gateway.Wavecell1MobyLocalNotify;
  else if (gateway === "Wavecell-1moby_Local_OTP")
    return Gateway.Wavecell1MobyLocalOTP;

  if (/^M360/.test(gateway) || gateway === "ViHAT-MKT" || /^CTL/.test(gateway)) {
    gateway = String(gateway).replace("-", "");
  }

  return Gateway[gateway] || "-";
};

export { GatewayColor, GatewayName };



// WEBPACK FOOTER //
// ./src/config/gateway.js